import api from './axios';

export const getCouponsApi    = ()           => api.get('/admin/coupons');
export const createCouponApi  = (data)       => api.post('/admin/coupons', data);
export const updateCouponApi  = (id, data)   => api.put(`/admin/coupons/${id}`, data);
export const deleteCouponApi  = (id)         => api.delete(`/admin/coupons/${id}`);
export const toggleCouponApi  = (id)         => api.patch(`/admin/coupons/${id}/toggle`);
export const applyCouponApi   = (data)       => api.post('/cart/coupon', data);
